import axiosInstance from 'axios'
import { BASE_URL } from './helpers/constants'

window.axios = axiosInstance.create({
	baseURL: BASE_URL,
	headers: {
		'Accept-Language': localStorage.getItem('lang') || 'ar'
	}
});

export default window.axios;